import NG from "./assets/seal.webp"

export type SealMaskProps = { serial: string; className?: string; publicHash: string }

export function SealMask({ serial, publicHash, className }: SealMaskProps) {
	return (
		<div className={`relative inline-block w-full max-w-md ${className ?? ""}`}>
			<img src={NG || "/placeholder.svg"} alt="Imagem do Selo" className="w-full h-auto block" />

			<div className="absolute left-[10%] top-[7%] rounded-sm bg-black/50 px-[3%] py-[0.5%]">
				<p className="text-[clamp(0.75rem,4vw,1.5rem)] font-bold font-[Doto] text-white leading-tight">{serial}</p>
			</div>

			<div className="absolute left-1/2 -translate-x-1/2 top-[52%] rounded-sm px-[3%] py-[0.5%] text-[#6a6768]">
				<p className="text-[clamp(0.875rem,5vw,1.75rem)] leading-tight text-center">{publicHash}</p>
			</div>
		</div>
	)
}
